import NoData from '../../../../../../components/NoData';
import { Card } from './styles';

interface ITotalConsultsCard {
  total: number
}

export default function TotalConsultsCard({ total }: ITotalConsultsCard) {
  return (
    <Card>
      <div className="card-title">
        <div>Total de Consultas</div>
      </div>

      {!!total && (
        <>
          <div className="card-main">
            <div style={{fontSize: '32px'}}>
              {total}
            </div>
            <small>
              {(total > 1 ? 'Consultas' : 'Consulta')}
            </small>
          </div>
        </>
      )}

      {(!total) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não foi realizada nenhuma consulta no período selecionado
            </>
          )}
        />
      )}
    </Card>
  );
}
